<div class="cms-panel">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="header-title">
        <app-back-button
          [title]="'SATELLITE_IMAGES_AND_INDICES_MOSAIC' | translate"
          [parentRoute]="'/crop-monitoring'"></app-back-button>
      </div>
    </div>
    <div class="rows-container">
      <div class="table-header">
        <div class="col-meta">
          <span class="th-label">{{ "Image Date" | translate }}</span>
          <span class="th-label">{{ "Satellite Name" | translate }}</span>
          <span class="th-label">{{ "CLOUD_COVER" | translate }}</span>
          <span class="th-label">{{ "COORDINATES_REGION" | translate }}</span>
        </div>
        @for (col of layerColumns; track col) {
          <div class="col-layer-header">
            {{ col | uppercase }}
          </div>
        }
        <div class="col-archive-header"></div>
      </div>
      @if (isLoading) {
        <div class="loading-indicator">
          <p>{{ "Loading..." | translate }}</p>
        </div>
      } @else {
        @for (row of rows; track row.id) {
          <div class="data-row">
            <div class="col-meta">
              <div class="meta-group date">
                {{ row.date | date: "dd.MM.yyyy" }}
              </div>
              <div class="meta-group satellite">
                {{ row.satelliteName }}
              </div>
              <div class="meta-group cloud">
                @if (row.cloudCover !== null) {
                  {{ row.cloudCover | number:'1.2-2' }}%
                } @else {
                  {{ "No data" | translate }}
                }
              </div>
              <div class="meta-group coords">
                <div>{{ "lng" | translate }}: {{ row.coordinates.lon }}</div>
                <div>{{ "lat" | translate }}: {{ row.coordinates.lat }}</div>
                @if (row.regionIds?.length) {
                  <div style="margin-top: 4px; color: var(--color-text-primary)">
                    @for (rid of row.regionIds.slice(0, 4); track rid) {
                      <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                        {{ getRegionById(rid) | serverTranslate: "names" }}
                      </div>
                    }
                    @if (row.regionIds.length > 4) {
                      <div
                        class="more-regions-badge"
                        [title]="getRegionsTooltip(row.regionIds)">
                        + {{ row.regionIds.length - 4 }}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            @for (col of layerColumns; track col) {
              <div class="col-layer-cell">
                @let layer = row.layers[col];
                <div
                  class="image-card"
                  [class.no-data]="!layer || !layer.imageUrl || layer.hasError">
                  @if (layer && layer.imageUrl && !layer.hasError) {
                    @if (layer.isLoading) {
                      <div class="img-loader"></div>
                    }
                    <img
                      [src]="layer.imageUrl"
                      [alt]="layer.name"
                      (load)="layer.isLoading = false"
                      (error)="layer.isLoading = false; layer.hasError = true"
                      [hidden]="layer.isLoading" />
                    @if (layer.downloadId) {
                      <button
                        class="btn-download"
                        (click)="onDownloadLayer(layer)"
                        [title]="'Download' | translate">
                        <img
                          src="assets/icons/main/light/map-download.svg"
                          alt="download" />
                      </button>
                    }
                  } @else {
                    <div class="state-content no-data">
                      <span class="text-tiny">{{ "No data" | translate }}</span>
                    </div>
                  }
                </div>
              </div>
            }
            <div class="col-archive">
              @if (row.mediadataPath) {
                <div class="archive-actions">
                  <button
                    class="btn-archive-download"
                    (click)="onDownloadArchive(row)"
                    [title]="'Download archive' | translate">
                    <img
                      src="assets/icons/main/light/ico-download.svg"
                      alt="download archive" />
                  </button>
                  @if (row.sizeMb) {
                    <span class="size-label">{{ row.sizeMb }} {{ "Mb" | translate }}</span>
                  }
                </div>
              } @else {
                <span class="text-tiny text-placeholder">{{ "No data" | translate }}</span>
              }
            </div>
          </div>
        }
      }
    </div>
    <app-custom-paginator
      [first]="first"
      [pageSize]="pageSize"
      [totalRecords]="totalCount"
      [rowsPerPageOptions]="[10, 20, 50]"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"></app-custom-paginator>
  </div>
  <div class="data-filters">
    <div class="filter-header">
      <h3>{{ "FILTERS" | translate }}</h3>
      <span class="icon-filter"></span>
    </div>
    <form
      class="filter-form"
      (ngSubmit)="applyFilters()">
      <div class="form-group">
        <label>{{ "Region" | translate }}</label>
        <msf-tree-select
          [(model)]="filters.regionId"
          [service]="regionManagerService"
          serviceMethod="getRegionsObservable"
          [placeholder]="'Select Region' | translate"
          [showClear]="true"
          [treeBy]="'parentId'" />
      </div>
      <div class="form-group">
        <label>{{ "DATA_SOURCE" | translate }}</label>
        <select
          class="form-control"
          [(ngModel)]="filters.satelliteName"
          name="satelliteName">
          <option
            [ngValue]="null"
            disabled
            selected>
            {{ "SELECT_SATELLITE" | translate }}
          </option>
          <option value="Sentinel">{{ "SATELLITE_SENTINEL" | translate }}</option>
          <option value="Landsat">{{ "SATELLITE_LANDSAT" | translate }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>{{ "Период" | translate }}</label>
        <div class="period-range">
          <app-date-picker
            [(ngModel)]="filters.startDate"
            name="startDate"
            [placeholder]="'Date From' | translate"
            [showIcon]="true"
            [showClear]="true"
            [maxDate]="filters.endDate"></app-date-picker>
          <app-date-picker
            [(ngModel)]="filters.endDate"
            name="endDate"
            [placeholder]="'Date To' | translate"
            [showIcon]="true"
            [showClear]="true"
            [minDate]="filters.startDate"></app-date-picker>
        </div>
      </div>
      <div class="form-group cloud-cover-filter">
        <label for="crop-monitoring-max-cloud-cover">{{ "MAX_CLOUD_COVER" | translate }}</label>
        <div class="cloud-cover-control">
          <input
            id="crop-monitoring-max-cloud-cover"
            class="cloud-cover-slider"
            type="range"
            min="0"
            max="100"
            step="5"
            [(ngModel)]="filters.maxCloudCover"
            name="maxCloudCover"
            (ngModelChange)="onMaxCloudCoverChange($event)" />
          <span class="cloud-cover-value">{{ filters.maxCloudCover }}%</span>
        </div>
      </div>
      <div class="form-actions">
        <app-primary-button
          width="100%"
          [title]="'APPLY'"
          (action)="applyFilters()">
        </app-primary-button>
        <app-secondary-button
          width="100%"
          [title]="'primeng.clear'"
          (action)="resetFilters()">
        </app-secondary-button>
      </div>
    </form>

    <div class="data-updated-banner" *ngIf="lastUpdatedAt">
      {{ "Data updated" | translate }} {{ lastUpdatedAt | date:'dd.MM.yyyy HH:mm' }}
    </div>
  </div>
</div>
